<adapt-dialog [maxWidth]="1000">
    <h3 adapt-dialog-title>Edit {{team.name}} roles</h3>

    <div adapt-dialog-content>
        <adapt-team-roles [team]="team"
                          [isEditing]="true"
                          [nested]="true"></adapt-team-roles>
    </div>

    <adapt-standard-dialog-buttons adapt-dialog-footer
                                   saveButtonPreset="close"
                                   [hideCancelButton]="true"
                                   (saveClick)="resolve()"></adapt-standard-dialog-buttons>
</adapt-dialog>

<adapt-context-sidebar-content context="dialog">
    <h2 context-sidebar-title>Group roles</h2>

    <p>Understanding the roles your group performs, as well as who is accountable for those roles,
        helps to answer the question <i>'Who does what within this group?'</i>.</p>

    <hr />
    <h4>Assigning people to a role</h4>
    <p>
        You can assign a person to a specific role by dragging the person to the
        <b>Drop person here</b> area within the role.
    </p>

    <h4>Pinning roles to the group</h4>
    <p>You can pin existing roles to the group by clicking the <b>Pin existing roles to X roles</b> button,
        then selecting the roles you would like to be visible within the group.</p>

    <h4>Adding new roles</h4>
    <p>
        You can create a new role within the platform by clicking the
        <b>Create new role</b> button, then giving the role a name.
    </p>

    <h4>Adding external people to group roles</h4>
    <p>You may have people who perform roles related to the group, while not being directly part of the group.
        An example would be an advisor, or other external stakeholders.
        You can click the <b>Add external person to X roles</b> button to display these people within the group roles.
    </p>
</adapt-context-sidebar-content>
